import React, { useEffect, useMemo, useRef, useState } from "react";
import MenuComponent from "../../components/MenuComponent/MenuComponent";
import { useInventory } from "./useInventory";
import SearchIcon from "../../Assets/search-icon.png";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import CloseLogo from "../../Assets/close_icon.png";
import PlusLogo from "../../Assets/plus-icon.png";
import MinusLogo from "../../Assets/minus-icon.png";
import RefreshIcon from "../../Assets/refresh-icon.png";
import moment from "moment";
import "./Inventory.css";

const Inventory = () => {
  const {
    dataUser,
    menu,
    setMenu,
    dataTempSearch,
    searchBarang,
    setSearchBarang,
    popUpTambahStock,
    setPopUpTambahStock,
    jumlahTambah,
    setJumlahTambah,
    handlePickData,
    handleTambahStock,
    popUpDetail,
    handlePickDetail,
    dataDetail,
    dataPick,
    handleCloseDetail,
    setRefresh,
    popUpTambahInventory,
    setPopUpTambahInventory,

    searchListPopUp,
    setSearchListPopUp,
    dataTempSearchList,
    handleChangeChecklist,
    handleTambahInventory,
    keteranganTambahKurang,
    setKeteranganTambahKurang,
    popUpKurangStock,
    setPopUpKurangStock,
    filterFrom,
    setFilterFrom,
    filterUntil,
    setFilterUntil,
    handleExportStock,
  } = useInventory();

  const PAGE_SIZE = 40;
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const scrollRootRef = useRef(null);
  const loadMoreRef = useRef(null);

  const sortDataSearch = useMemo(() => {
    if (!dataTempSearch) return [];
    return [...dataTempSearch].sort((a, b) => {
      if (a.value < b.value) return -1;
      if (a.value > b.value) return 1;
      return 0;
    });
  }, [dataTempSearch]);

  const displayedData = useMemo(
    () => sortDataSearch.slice(0, visibleCount),
    [sortDataSearch, visibleCount]
  );

  const hasMore = visibleCount < sortDataSearch.length;

  useEffect(() => {
    setVisibleCount(PAGE_SIZE);
    if (scrollRootRef.current) scrollRootRef.current.scrollTop = 0;
  }, [searchBarang]);

  useEffect(() => {
    if (!hasMore) return;
    const el = loadMoreRef.current;
    if (!el) return;
    const rootEl = scrollRootRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setVisibleCount((prev) =>
            Math.min(prev + PAGE_SIZE, sortDataSearch.length)
          );
        }
      },
      {
        root: rootEl || null,
        rootMargin: "200px",
        threshold: 0,
      }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, sortDataSearch.length]);

  const sortNamaBarang =
    dataTempSearchList &&
    dataTempSearchList.sort(function (a, b) {
      if (a.value < b.value) {
        return -1;
      }
      if (a.value > b.value) {
        return 1;
      }
      return 0;
    });

  return (
    <>
      {popUpTambahStock ? (
        <PopUpComponent>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "6px",
            }}
          >
            <p>{dataPick.value}</p>
            <img
              style={{ width: "36px", height: "36px", cursor: "pointer" }}
              src={CloseLogo}
              onClick={() => {
                setPopUpTambahStock(false);
                setKeteranganTambahKurang("");
              }}
              alt="edit_logo"
            />
          </div>
          <div style={{ display: "flex", alignItems: "end" }}>
            <div style={{ marginRight: "6px" }}>
              <p
                style={{
                  margin: "6px 0",
                }}
              >
                Jumlah
              </p>
              <input
                style={{
                  padding: "6px",
                }}
                type="number"
                placeholder="Jumlah"
                value={jumlahTambah}
                onChange={(e) => setJumlahTambah(e.target.value)}
                onWheel={(e) => e.target.blur()}
              />
            </div>
            <textarea
              placeholder="Keterangan"
              value={keteranganTambahKurang}
              onChange={(e) =>
                setKeteranganTambahKurang(e.target.value.toUpperCase())
              }
              style={{ resize: "none", height: "26px" }}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "6px",
            }}
          >
            <button
              style={{
                border: "none",
                background: "red",
                color: "white",
                padding: "8px 16px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={() => handleTambahStock()}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpKurangStock ? (
        <PopUpComponent>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "6px",
            }}
          >
            <p>{dataPick.value}</p>
            <img
              style={{ width: "36px", height: "36px", cursor: "pointer" }}
              src={CloseLogo}
              onClick={() => {
                setPopUpKurangStock(false);
                setKeteranganTambahKurang("");
              }}
              alt="edit_logo"
            />
          </div>
          <div style={{ display: "flex", alignItems: "end" }}>
            <div style={{ marginRight: "6px" }}>
              <p
                style={{
                  margin: "6px 0",
                }}
              >
                Jumlah
              </p>
              <input
                style={{
                  padding: "6px",
                }}
                type="number"
                placeholder="Jumlah"
                value={jumlahTambah}
                onChange={(e) => setJumlahTambah(e.target.value)}
                onWheel={(e) => e.target.blur()}
              />
            </div>
            <textarea
              placeholder="Keterangan"
              value={keteranganTambahKurang}
              onChange={(e) =>
                setKeteranganTambahKurang(e.target.value.toUpperCase())
              }
              style={{ resize: "none", height: "26px" }}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "6px",
            }}
          >
            <button
              style={{
                border: "none",
                background: "red",
                color: "white",
                padding: "8px 16px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={() => handleTambahStock()}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}

      {popUpDetail ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
            height: "90vh",
            width: "88%",
            overflowY: "scroll",
            padding: "12px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <p>{dataPick.value}</p>
            <img
              style={{ width: "36px", height: "36px", cursor: "pointer" }}
              src={CloseLogo}
              onClick={() => handleCloseDetail()}
              alt="edit_logo"
            />
          </div>
          <div style={{ display: "flex", gap: "12px" }}>
            <div>
              <p style={{ margin: "6px 0" }}>Dari</p>
              <input
                style={{ height: "24px", width: "102px" }}
                type="date"
                value={filterFrom}
                onChange={(e) => setFilterFrom(e.target.value)}
              />
            </div>
            <div>
              <p style={{ margin: "6px 0" }}>Sampai</p>
              <input
                style={{ height: "24px", width: "102px" }}
                type="date"
                value={filterUntil}
                onChange={(e) => setFilterUntil(e.target.value)}
              />
            </div>
          </div>
          <div
            style={{
              overflow: "scroll",
              background: "#e5f4d4",
              borderRadius: "8px",
              marginTop: "12px",
            }}
          >
            <table
              className="font10-mobile-bpb"
              style={{ width: "100%", borderSpacing: 0 }}
            >
              <tr style={{ textAlign: "left" }}>
                <th
                  style={{ padding: "12px 0 12px 12px", textAlign: "center" }}
                >
                  No.
                </th>
                <th style={{ padding: "12px 0 12px 12px" }}>Tanggal</th>
                <th style={{ padding: "12px 0 12px 12px" }}>Status</th>
                <th style={{ padding: "12px 0 12px 12px" }}>Bagian</th>
                <th style={{ padding: "12px 0 12px 12px" }}>Jumlah</th>
                <th style={{ padding: "12px 0 12px 12px" }}>Sisa</th>
                <th style={{ padding: "12px 0 12px 12px" }}>Updated By</th>
                <th style={{ padding: "12px 0 12px 12px" }}>Keterangan</th>
              </tr>
              {dataDetail &&
                dataDetail.map((ele, index) => {
                  return (
                    <tr
                      style={
                        ele.type == "Tambah" && index % 2 === 0
                          ? { background: "white", color: "green" }
                          : ele.type == "Tambah" && index % 2 === 1
                          ? { background: "#F7F7F7", color: "green" }
                          : !ele.type == "Tambah" && index % 2 === 0
                          ? { background: "white", color: "red" }
                          : { background: "#F7F7F7", color: "red" }
                      }
                    >
                      <td style={{ padding: "12px 0", textAlign: "center" }}>
                        {index + 1}.
                      </td>
                      <td style={{ padding: "12px 0 12px 12px" }}>
                        {moment(ele.updateTime).format("DD-MM-YY, HH:mm:ss")}
                      </td>
                      <td style={{ padding: "12px 0 12px 12px" }}>
                        {ele && ele.type === "Tambah" ? "Tambah" : "Kurang"}
                      </td>
                      <td style={{ padding: "12px 0 12px 12px" }}>
                        {ele && ele.bagian}
                      </td>
                      <td
                        style={{
                          padding: "6px",
                          textAlign: "center",
                        }}
                      >
                        {ele.jumlah}
                      </td>
                      <td
                        style={{
                          padding: "6px",
                          textAlign: "center",
                        }}
                      >
                        {ele.type === "Tambah"
                          ? Number(ele.jumlahBefore) + ele.jumlah
                          : Number(ele.jumlahBefore) - ele.jumlah}
                      </td>
                      <td style={{ padding: "12px 0 12px 12px" }}>
                        {ele.approver.split(" ").slice(0, 1).join(" ")}
                      </td>
                      <td style={{ padding: "12px 0 12px 12px" }}>
                        {ele.keterangan ? ele.keterangan : ""}
                      </td>
                    </tr>
                  );
                })}
            </table>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}

      {popUpTambahInventory ? (
        <PopUpComponent className="wrapper_popup_pick">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "6px",
              position: "sticky",
              top: "0",
              background: "white",
            }}
          >
            <p>Tambah Inventory dari List</p>
            <img
              style={{ width: "36px", height: "36px", cursor: "pointer" }}
              src={CloseLogo}
              onClick={() => {
                setPopUpTambahInventory(false);
              }}
              alt="edit_logo"
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                display: "flex",
                position: "sticky",
                top: "48px",
                background: "white",
              }}
            >
              <input
                className="search_box_inventory"
                type="text"
                placeholder="Cari Barang"
                value={searchListPopUp}
                onChange={(e) => setSearchListPopUp(e.target.value)}
              />
              <p
                className="btn_reset_search_inventory"
                style={{ margin: "0 12px 12px 0" }}
                onClick={() => setSearchListPopUp("")}
              >
                Reset
              </p>
            </div>
            <button
              className="button-kirim-bpb"
              style={{ height: "32px" }}
              onClick={() => handleTambahInventory()}
            >
              Tambah
            </button>
          </div>
          <div style={{ width: "100%" }}>
            <table style={{ width: "100%" }}>
              <tr>
                <th>No.</th>
                <th>Item</th>
                <th></th>
              </tr>

              {sortNamaBarang &&
                sortNamaBarang.map((data, index) => {
                  return (
                    <tr
                      style={
                        index % 2 === 0
                          ? { background: "white", fontSize: "14px" }
                          : { background: "#F7F7F7", fontSize: "14px" }
                      }
                    >
                      <td style={{ textAlign: "center", padding: "12px 0" }}>
                        {index + 1}.
                      </td>
                      <td style={{ padding: "12px 6px" }}>{data.label}</td>
                      <td>
                        <input
                          type="checkbox"
                          name="isInventory"
                          checked={data.isInventory}
                          onClick={(e) => handleChangeChecklist(data.id, e)}
                          style={{ width: "20px", height: "20px" }}
                        />
                      </td>
                    </tr>
                  );
                })}
            </table>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {dataUser !== null ? <MenuComponent setMenu={setMenu} menu={menu} /> : ""}
      <div className="container-inventory">
        <div className="wrapper-inventory">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "12px",
            }}
          >
            <div style={{ display: "flex", gap: "8px" }}>
              <input
                className="search_box_inventory"
                type="text"
                placeholder="Cari Barang"
                value={searchBarang}
                onChange={(e) => setSearchBarang(e.target.value)}
              />
              <p
                className="btn_reset_search_inventory"
                style={{ margin: "0 0px 12px 0" }}
                onClick={() => setSearchBarang("")}
              >
                Reset
              </p>
              <img
                src={RefreshIcon}
                alt="refresh"
                style={{
                  width: "30px",
                  height: "30px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setRefresh(true);
                }}
              />
              <button
                className="btn_reset_search_inventory"
                style={{
                  width: "98px",
                  border: "none",
                  height: "31px",
                  background: "green",
                }}
                onClick={() => handleExportStock()}
              >
                Export Stock
              </button>
            </div>
            <div
              className="wrapper-button-tambah"
              onClick={() => setPopUpTambahInventory(true)}
            >
              <p className="button-tambah">+</p>
              <button className="text-button-tambah">New Inventory</button>
            </div>
          </div>
          <div className="wrapper-table" ref={scrollRootRef}>
            <table
              className="font10-mobile-bpb"
              style={{
                width: "100%",
                borderSpacing: 0,
                textAlign: "left",
                borderRadius: "8px",
                marginRight: "6px",
                background: "#e5f4d4",
              }}
            >
              <tr>
                <th
                  style={{
                    padding: "12px 8px",
                    width: "8%",
                  }}
                >
                  No.
                </th>
                <th style={{ padding: "12px 8px" }}>NAMA BARANG</th>
                <th style={{ padding: "12px 8px" }}>JUMLAH</th>
                <th style={{ padding: "12px 8px" }}>LAST UPDATE</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
              {displayedData &&
                displayedData.map((data, index) => {
                  return (
                    <tr
                      style={
                        index % 2 === 0
                          ? { background: "white", fontSize: "14px" }
                          : { background: "#F7F7F7", fontSize: "14px" }
                      }
                    >
                      <td
                        className="td-table-inventory"
                        style={{
                          width: "8%",
                        }}
                      >
                        {index + 1}.
                      </td>
                      <td className="td-table-inventory">{data.value}</td>
                      <td className="td-table-inventory">
                        {data && data.jumlah}
                      </td>
                      <td className="td-table-inventory">
                        {data.updatedBy &&
                          data.updatedBy.split(" ").slice(0, 1).join(" ")}{" "}
                        -{" "}
                        {data.updateTime
                          ? moment(data && data.updateTime).format(
                              "DD-MM-YY, HH:mm:ss"
                            )
                          : ""}
                      </td>
                      <td className="td-table-inventory">
                        <img
                          className="image-inventory"
                          src={PlusLogo}
                          onClick={() => {
                            setPopUpTambahStock(true);
                            handlePickData(data);
                          }}
                        />
                      </td>
                      <td className="td-table-inventory">
                        <img
                          className="image-inventory"
                          src={MinusLogo}
                          onClick={() => {
                            setPopUpKurangStock(true);
                            handlePickData(data);
                          }}
                        />
                      </td>
                      <td className="td-table-inventory">
                        <img
                          className="image-inventory"
                          src={SearchIcon}
                          onClick={() => handlePickDetail(data)}
                        />
                      </td>
                    </tr>
                  );
                })}
            </table>
            {/* Sentinel for infinite scroll */}
            <div ref={loadMoreRef} style={{ height: "1px" }} />
            {hasMore ? (
              <div
                style={{ padding: "12px", textAlign: "center", color: "#555" }}
              >
                Loading more...
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};
export default Inventory;
